import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, ArrowUp } from "lucide-react";
import { WhatsAppIcon } from "./icons";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL } from "@/constants/site";
import { lenisStore } from "@/lib/scroll";

export const FloatingUI = () => {
    const [showTop, setShowTop] = useState(false);

    useEffect(() => {
        const onScroll = () => setShowTop(window.scrollY > 600);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <>
            <a
                data-testid="mobile-call-bar"
                href={PHONE_TEL}
                className="fixed bottom-0 inset-x-0 z-40 md:hidden flex items-center justify-center gap-2.5 bg-gradient-to-r from-gold-dark via-gold to-gold-light py-4 font-semibold text-midnight-900 shadow-[0_-10px_30px_rgba(0,0,0,0.4)]"
            >
                <Phone size={19} strokeWidth={2.5} />
                Appelez-nous — {PHONE_DISPLAY}
            </a>

            <motion.a
                data-testid="whatsapp-float"
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Discuter sur WhatsApp"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 2.2, type: "spring", stiffness: 200, damping: 15 }}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                className="fixed right-5 bottom-[4.75rem] md:bottom-6 z-40 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.4)]"
            >
                <WhatsAppIcon size={28} />
            </motion.a>

            <AnimatePresence>
                {showTop && (
                    <motion.button
                        data-testid="back-to-top"
                        onClick={() => lenisStore.current?.scrollTo(0, { duration: 1.4 })}
                        aria-label="Retour en haut de page"
                        initial={{ opacity: 0, scale: 0.6 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.6 }}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        className="fixed right-5 bottom-[8.75rem] md:bottom-24 z-40 flex items-center justify-center w-11 h-11 rounded-full border border-gold/50 bg-[#0A0E17]/80 backdrop-blur-md text-gold"
                    >
                        <ArrowUp size={18} strokeWidth={2.5} />
                    </motion.button>
                )}
            </AnimatePresence>
        </>
    );
};
